import {
  TestimonialsArticles,
  TestimonialsHighlight
} from "components/UI/molecules";

export const SellTestimonials = () => (
  <div className="sell-testimonials">
    <TestimonialsHighlight />
    <TestimonialsArticles />
  </div>
);
